import config from "~/config";
import { del, get, post, put } from "./apiHelper";
import { withAuth } from "./utilHelper";
import {
  SaveUserRequest,
  SaveUserPwdRequest,
  SaveSchedulerInfoRequest,
  LoginUserRequest,
  ValidateVerifCodeRequest,
  GetUserResponse,
  RequestPasswordResetRequest,
  ResetPasswordFields,
  GetOAuthClientResponse,
  GenerateOAuthCodeRequest,
  GenerateOAuthCodeResponse,
  GetOutOfOfficeResponse
} from "~/types/backend";

const oaAxiosOptions = {
  baseURL: config.API_OA_URL as string,
  withCredentials: false,
}

export const getAuthUser = () => get<GetUserResponse>('/me');

export const saveAuthUser = (data: SaveUserRequest) => put('/me', data);

export const saveAuthUserPwd = (data: SaveUserPwdRequest) => put('/me/password', data);

export const uploadAuthUserImg = (data: FormData) => post('/me/image', data, { headers: { 'Content-Type': 'multipart/form-data' } });

export const deleteAuthUserImg = () => del('/me/image');

export const loginUser = (data: LoginUserRequest) => post('/login', data);

export const logoutUser = () => post(withAuth('/logout'), {});

export const validateVerifCode = (data: ValidateVerifCodeRequest) => post(withAuth('/2fa/validate'), data);

export const resendVerifCode = () => post(withAuth('/2fa/restart'), {});

export const getUser = (id: string) => get<GetUserResponse>(`/user/${id}`);

export const requestPasswordReset = (data: RequestPasswordResetRequest) => post('/user/request-password-reset', data);

export const preResetPassword = (token: string) => post(`/user/pre-reset-password/${token}`, {});

export const resetPassword = (token: string, data: ResetPasswordFields) => put(`/user/reset-password/${token}`, data);

export const preActivateAccount = (token: string) => post(`/user/pre-activate-account/${token}`, {});

export const activateAccount = (token: string, data: ResetPasswordFields) => put(`/user/activate-account/${token}`, data);

export const verifyEmail = (token: string) => put(`/user/verify-email/${token}`, {});

export const loginWithAuth0 = (idToken: string) => post('/auth0/login', { idToken });

export const saveSchedulerInfo = (id: number, data: SaveSchedulerInfoRequest) => put(`/user/${id}/scheduler-info`, data);

export const getOAuthClient = (clientId: string) => get<GetOAuthClientResponse>(`/client?client_id=${encodeURIComponent(clientId)}`, oaAxiosOptions);

export const generateOAuthCode = (data: GenerateOAuthCodeRequest) => post<GenerateOAuthCodeResponse>('/oauth/code', data);

// Out Of Office

export const getOutOfOffice = (id: number) => get<GetOutOfOfficeResponse>(`/user/${id}/out-of-office`);